import React from "react"
import PropTypes from "prop-types"
import { useTracker } from "@modules/analytics"
import ToggleCheckbox from "@modules/ui/components/ToggleCheckbox"
import useToggleBuildChecks from "../hooks/useToggleBuildChecks"
import { siteBuildsSettings as siteBuildsSettingsText } from "@modules/locales/default.js"

const propTypes = {
  siteId: PropTypes.string.isRequired,
  buildChecksEnabled: PropTypes.bool,
}

function EnableBuildChecks({ siteId, buildChecksEnabled }) {
  const [toggleBuildChecks, { errorAlert }] = useToggleBuildChecks(siteId)
  const { trackButtonClicked } = useTracker()

  return (
    <React.Fragment>
      <ToggleCheckbox
        id="enable-build-checks-checkbox"
        label={siteBuildsSettingsText.labels.enableBuildChecks}
        checked={!!buildChecksEnabled}
        onChange={() => {
          trackButtonClicked(`toggle build checks`, {
            uiSource: `Site Settings`,
          })

          toggleBuildChecks()
        }}
      />
      {errorAlert}
    </React.Fragment>
  )
}

EnableBuildChecks.propTypes = propTypes

export default EnableBuildChecks
